<template>
  <div class="modal fade">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      persistent
      max-width="600px"
      content-class="ims-standard-dialog"
    >
      <v-card class="ims-modal-card">
        <v-card-title class="title ims-modal-header">
          <span class="headline">Influencer Payout Verification</span>
          <v-spacer></v-spacer>
          <v-btn icon color="secondary" aria-label="Close" title="Close" @click="$emit('input')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="ims-modal-body">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <label>Submitted By: </label>
                <p>
                  <a :href="'https://www.tiktok.com/@' + payoutData.handle" target="_blank" v-if="payoutData.platform === 'tiktok'">
                  <img src="/static/img/tiktok-32.png" width="20px" /> @{{ payoutData.handle }}
                  </a>
                  <a :href="'https://instagram.com/' + payoutData.handle" target="_blank" v-else>
                  <v-icon color="#000000" small>mdi-instagram</v-icon> @{{ payoutData.handle }}
                  </a>
                </p>
              </v-flex>
              <v-flex xs12 sm6>
                <label>For Campaign: </label>
                <p>{{ payoutData.campaignName }}</p>
              </v-flex>
              <v-flex xs12 sm6>
								<label>Submitted Date:</label>
                <p>{{ changeDateFormat(payoutData.createdAt) }}</p>
              </v-flex>
              <v-flex xs12 sm6 v-if="showRequiredActions()">
                <label>To Make Payment:</label>
                <p>{{ changeDateFormat(payoutData.toMakePaymentAt) }} ({{ calDaysLeft(payoutData.toMakePaymentAt) }})</p>
              </v-flex>
              <v-divider></v-divider>
              <v-flex xs12 sm6 v-if="showRequiredActions()">
                <label>Engagement Rate</label>
                <p>{{(influencerData.engagementRate * 100).toFixed(2)}} %</p>
              </v-flex>
              <v-flex xs12 sm6 v-if="showRequiredActions()">
                <label v-if="payoutData.platform === 'tiktok'">TikTok Followers</label>
                <label v-else>Instagram Followers</label>
                <p>{{influencerData.followers}}</p>
              </v-flex>
              <v-flex xs12 sm6>
                <label>Receiving Bank A/C No:</label>
                <small>(omit dashes)</small>
                <p>{{influencerData.bankAccount}}</p>
              </v-flex>
              <v-flex xs12 sm6>
                <label>Receiving A/C Name</label>
                <p>{{influencerData.fullName}}</p>
              </v-flex>
              <v-flex xs12 sm6>
                <label>Bank</label>
                <p>{{influencerData.bankName}}</p>
              </v-flex>
              <v-flex xs12 sm6>
                <label>Mailing Address</label>
                <p>{{influencerData.mailingAddress}}</p>
              </v-flex>
              <v-flex xs12 class="mb-2 grey lighten-2" v-if="!showRequiredActions()">
                <v-card>
                  <v-card-text>                    
                    <v-row align="center" justify="center">
                      <v-col cols="12" md="6" sm="12" v-if="moneyoutData.bankSwiftCode">
                        <!-- <v-text-field label="sss" hide-details single-line outlined dense></v-text-field> -->
                        <label>Bank Swift Code</label>
                        <p><b>{{moneyoutData.bankSwiftCode ? moneyoutData.bankSwiftCode : '-'}}</b></p>
                      </v-col>
                      <v-col xs='12' sm='6' v-if="moneyoutData.BIBREF">
                        <label>BIB REF</label>
                        <p><b>{{moneyoutData.BIBREF}}</b></p>
                      </v-col>
                      <v-col xs='12' sm='6' v-if="moneyoutData.FTREF">
                        <label>FT REF</label>
                        <p><b>{{moneyoutData.FTREF}}</b></p>
                      </v-col>
                      <v-col xs='12' sm='6' v-if="moneyoutData.REF">
                        <label>REF</label>
                        <p><b>{{moneyoutData.REF}}</b></p>
                      </v-col>
                      <v-col xs='12' sm='6' v-if="moneyoutData.billingContact">
                        <label>Billing Contact</label>
                        <p><b>{{moneyoutData.billingContact}}</b></p>
                      </v-col>
                      <v-col xs='12' sm='6' v-if="submissionData.payoutAmount">
                        <label>Payout Amount</label>
                        <p>$ <b>{{submissionData.payoutAmount}}</b></p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-flex>
              <!-- <v-flex xs12 sm6 class="mb-2">
                <label>Satisfication Level on Campaign:</label>
                <small>(1 to 5)</small>
                <v-rating
                  background-color="grey"
                  v-model="payoutData.satisfaction_level_on_campaign"
                  color="secondary" size="30"
                  readonly dense
                ></v-rating>
              </v-flex>
              <v-flex xs12 sm6 class="mb-2">
                <label>Satisfication Level on Kobe:</label>
                <small>(1 to 5)</small>
                <v-rating
                  background-color="grey"
                  v-model="payoutData.satisfaction_level_on_kobe"
                  color="secondary" size="30"
                  readonly dense
                ></v-rating>
              </v-flex>
              <v-flex xs12 sm12>
                <label>Satisfication Level on Advertiser:</label>
                <small>(1 to 5)</small>
                <v-rating
                  background-color="grey"
                  v-model="payoutData.satisfaction_level_on_advertiser"
                  color="secondary" size="30"
                  readonly dense
                ></v-rating>
              </v-flex> -->
              <v-flex xs12 sm12 class="mb-2">
                <label>How would you rate your overall experience with the client?</label>
                <v-rating
                  background-color="grey"
                  v-model="payoutData.satisfaction_level_on_advertiser"
                  color="secondary" size="30"
                  readonly dense
                ></v-rating>
              </v-flex>
              <v-flex xs12 sm12 class="mb-2">
                <label>How would you rate your overall experience with Kobe?</label>
                <v-rating
                  background-color="grey"
                  v-model="payoutData.satisfaction_level_on_kobe"
                  color="secondary" size="30"
                  readonly dense
                ></v-rating>
              </v-flex>
              <v-flex xs12 sm12 class="mb-2" v-if="payoutData.collaboration">
                <label>What do you like about this collaboration?</label>
                <p class="mb-0" v-html="payoutData.collaboration"></p>
              </v-flex>
              <v-flex xs12 sm12 class="mb-2" v-if="payoutData.improved">
                <label>What are areas of improvement about this product/service that will be valuable feedback for them?</label>
                <p class="mb-0" v-html="payoutData.improved"></p>
              </v-flex>
              <v-flex xs12 sm12 class="mb-2" v-if="payoutData.promotingProducts">
                <label>What do you like most about this product/service you are promoting?</label>
                <p class="mb-0" v-html="payoutData.promotingProducts"></p>
              </v-flex>
              <v-flex xs12 sm12 class="mb-2" v-if="payoutData.audienceEnjoyment">
                <label>What do you think your audience enjoyed about your content?</label>
                <p class="mb-0" v-html="payoutData.audienceEnjoyment"></p>
              </v-flex>
            </v-layout>
          </v-container>
          <small></small>
        </v-card-text>
        <v-card-actions class="ims-modal-actions">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="$emit('input')">Close</v-btn>
          <!-- <v-btn color="green darken-1" text @click="updateAmount()" v-if="showRequiredActions()">Verify</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loadingDialog"      
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import PostAPIs from '../Post/postApi';
import InfluencerAPIs from '../Influencer/influencerAPIs';
import CampaignAPIs from '../Campaign/campaignAPIs';
import PairingAPIs from '../Pairing/pairingAPIs';
import clientAPIs from '../Client/clientAPIs';
import userAPIs from '../User/userAPIs';
import config from '@/config';
import campaignHelper from './campaignHelper';

export default {
  props: {
    value: Boolean,
    payout: Object
  },
  data () {
    return {
      payoutData: '',
      moneyoutData: {},
      influencerData: {},
      campaignData: {},
      clientData: {},
      pickDate: false,
      rules: {
        required: v => !!v || 'Amount is required'
      },
      submissionData: {
        toMakePaymentDate: '',
        payoutAmount: ''
      },
      pairedAmount: 0,
      clients: [],
      userCs: [],
      loadingDialog: false
      // statuses: ['APPROVED', 'PENDING', 'ON_HOLD', 'REJECTED']
    }
  },
  computed: {
    payoutExceeded: function() {
      if (this.submissionData.payoutAmount > this.pairedAmount) {
        return true
      }
      return false
    },
    diffPayoutAmount: function() {
      return Math.round((this.submissionData.payoutAmount - this.pairedAmount) * 100) / 100
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    }
  },
  methods: {
    buildFormData() {
      let payout = Object.assign({}, {
        payoutAmount: this.pairedAmount,
        toMakePaymentDate: this.submissionData.toMakePaymentDate
      })
      const formData = new FormData();
      formData.append('moneyout', JSON.stringify(this.constructMoneyOutData(this.moneyoutData)));
      formData.append('payout', JSON.stringify(payout));
      return formData;
    },
    updateAmount: async function() {
      if (this.pairedAmount === 0) {
        this.$swal('Incorrect Amount')
        return
      }
      const payload = Object.assign({}, {
        campaignID: this.payout.campaignID,
        handle: this.payout.handle,
        platform: this.payout.platform
      })
      await campaignHelper.invokeReportOwnerCheck(this, payload)
      // Nyein commented out cause payout exceeded amount error is shown rather than disallow.
      // else if (this.submissionData.payoutAmount > this.pairedAmount) {
      //   this.$swal('Payout amount cannot be greater than paried amount ')
      //   return
      // }
      let editData = this.buildFormData();
      this.$swal({
        title: 'Are you sure the amount is correct?',
        type: 'question',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.loadingDialog = true
          return InfluencerAPIs
            .editCampaignPayout(this.payoutData.id, editData)
            .then(response => {
              this.loadingDialog = false
              return response;
            })
            .catch(error => {
              this.loadingDialog = false
              this.$swal({
                text: error,
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        this.loadingDialog = false
        if (result.value) {
          this.$swal({
            title: 'Saved successfully',
            type: 'success'
          }).then(() => {
            this.$emit('input');
            this.$emit('payoutAmountUpdated');
          });
        }
      });
    },
    calDaysLeft: (date) => moment().to(date),
    changeDateFormat: (date) => moment(date).format('DD-MM-YYYY'),
    calCogsRate: (currentUse, cogs) => ((currentUse / cogs) * 100).toFixed(2),
    fetchRequireData: async function(payout) {
      this.loadingDialog = true
      // get Influencer Details
      if (payout.postID && !payout.influencerID) {
        PostAPIs
        .getPostById(payout.postID)
        .then(response => {
          this.loadingDialog = false
          this.getInfluencer(response.mainPost.influencerID)
        })
        .catch(err => {
          this.loadingDialog = false
          this.$swal({
            title: `Couldn't Load the Post`,
            type: 'error',
            text: err
          })
        }
        );
      } else {
        this.getInfluencer(payout.influencerID)
      }
      // get Campaign Details
      CampaignAPIs
        .getCampaign(payout.campaignID)
        .then(campaign => {
          this.campaignData = {
            id: campaign.id,
            budget: campaign.budget,
            cogs: campaign.budget * 0.3,
            name: campaign.name,
            assignedTo: campaign.assignedTo,
            clientID: campaign.clientID
          }
        })
        .catch(err => {
          this.$swal({
            title: `Couldn't load the Campaign`,
            type: 'error',
            text: err
          })
        })
      this.loadingDialog = false
    },
    getInfluencer(influencerID) {
      if (!influencerID) return
      InfluencerAPIs
        .getInfluencer(influencerID)
        .then(influencer => {
          this.loadingDialog = false
          this.influencerData = {
            influencerID: influencer.id,
            bankAccount: influencer.bankAccount,
            bankName: influencer.bankName,
            fullName: influencer.fullName,
            mailingAddress: influencer.mailingAddress
          }
          if (influencer.tiktokaudience) {
            this.influencerData.engagementRate = influencer.tiktokaudience ? influencer.tiktokaudience.user_profile.engagement_rate : '-'
            this.influencerData.followers = influencer.tiktokaudience ? influencer.tiktokaudience.user_profile.followers : '-'
          } else {
            this.influencerData.engagementRate = influencer.audience ? influencer.audience.user_profile.engagement_rate : '-'
            this.influencerData.followers = influencer.audience ? influencer.audience.user_profile.followers : '-'
          }
          this.getPairingDetails()
        })
        .catch(err => {
          this.loadingDialog = false
          this.$swal({
            title: `Couldn't Load Influencer Data`,
            type: 'error',
            text: err
          })
        })
    },
    getPairingDetails() {
      // get pairing Details
      this.loadingDialog = true
      this.pairedAmount = 0
      PairingAPIs
        .getPairedAmount(this.payoutData.campaignID, this.influencerData.influencerID)
        .then(pairingData => {
          this.loadingDialog = false
          if (pairingData.payout_details) {
            this.pairedAmount = pairingData.payout_details.amount
          }
        })
        .catch(err => {
          this.loadingDialog = false
          this.$swal({
            title: `Couldn't load the PairingData`,
            type: 'error',
            text: err
          })
        })
    },
    async fetchCSs() {
      try {
        const resp = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST);
        const users = resp.users;
        this.userCs = users.map(user => {
          return {
            name: `${user.firstName} ${user.lastName}`,
            id: user.id
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of CS',
          icon: 'error'
        });
      }
    },
    async fetchClient() {
      try {
        const resp = await clientAPIs.getAllClients(true);
        const clients = resp.data;
        this.clients = clients.map(user => {
          return {
            name: user.name,
            id: user.id
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of clients',
          icon: 'error'
        });
      }
    },
    constructMoneyOutData(input) {
      let data = Object.assign({}, input);
      if (input.id) {
        data.id = input.id
      }
      if (this.payoutData.platform === 'tiktok') {
        data.tiktokHandle = this.payoutData.handle
      } else {
        data.instagramHandle = this.payoutData.handle
      }
      data.payoutID = this.payoutData.id
      data.postID = this.payoutData.postID
      data.campaign = {
        name: this.campaignData.name,
        id: this.campaignData.id,
        clientID: this.campaignData.clientID
      }
      data.client = this.clients.find(c => c.id === this.campaignData.clientID)
      data.cs = this.userCs.filter(user => this.campaignData.assignedTo && this.campaignData.assignedTo.includes(user.id))
      data.bankAccountNo = this.influencerData.bankAccount
      data.receivingName = this.influencerData.fullName
      data.amount = this.submissionData.payoutAmount
      return data;
    },
    resetMoneyOutData() {
      this.moneyoutData = {
        bankAccountNo: '',
        csName: '',
        receivingName: '',
        instagramHandle: '',
        BIBREF: '',
        FTREF: '',
        bankSwiftCode: '',
        REF: '',
        postID: '',
        status: 'PENDING',
        billingContact: '',
        campaign: null,
        amount: 0
      }
    },
    showRequiredActions: function() {
      return config.userRoles.INFLUENCER !== this.currentUserRole;
    }
  },
  watch: {
    payout: function (newPayout) {
      this.fetchCSs();
      if (this.showRequiredActions()) {
        this.fetchClient();
      }
      this.fetchRequireData(newPayout)
      this.payoutData = newPayout
      if (newPayout.moneyOut) {
        this.moneyoutData = newPayout.moneyOut
      } else this.resetMoneyOutData()
      this.submissionData.toMakePaymentDate = newPayout.toMakePaymentAt
      this.submissionData.payoutAmount = newPayout.payoutAmount
    }
  },
  mounted() {
    this.resetMoneyOutData()
  }
  // computed: {
  //   bankNoErrors() {
  //     const errors = [];
  //     if (!this.$v.moneyoutData.bankAccountNo.$dirty) return errors;
  //     !this.$v.moneyoutData.bankAccountNo.required && errors.push('This field is required.');
  //     return errors;
  //   },
  //   receivingNameErrors() {
  //     const errors = [];
  //     if (!this.$v.moneyoutData.receivingName.$dirty) return errors;
  //     !this.$v.moneyoutData.receivingName.required && errors.push('This field is required.');
  //     return errors;
  //   },
  //   instagramHandleErrors() {
  //     const errors = [];
  //     if (!this.$v.moneyoutData.instagramHandle.$dirty) return errors;
  //     !this.$v.moneyoutData.instagramHandle.required && errors.push('This field is required.');
  //     return errors;
  //   }
  // }
}
</script>



// WEBPACK FOOTER //
// PayoutVerificationModal.vue?3d02ed62